import Model from '../utils/Model'

export class EQSize {
  constructor(code, name) {
    this.code = code
    this.name = name
  }
}

export const CODE_NAME = 'EQSize'

export const EQ_NULL_EQ_SIZE = new EQSize('', '')
export const EQ20_EQ_SIZE = new EQSize('20', "20'")
export const EQ40_EQ_SIZE = new EQSize('40', "40'")
export const EQ45_EQ_SIZE = new EQSize('45', "45'")
export const EQ10_EQ_SIZE = new EQSize('10', "10'")
export const EQRE_EQ_SIZE = new EQSize('50', '') // CARGO-8227，箱种新增:敞车/棚车/平车，对应的箱型为空
export const EQ53_EQ_SIZE = new EQSize('53', "53'") // CARGO-17729 新增 集装箱尺寸 53‘ 对应 系统业务模块 基本页签 箱型
export const EQ30_EQ_SIZE = new EQSize('30', "30'") // CARGO-22260 箱货信息 新增箱型30‘
export const EQ48_EQ_SIZE = new EQSize('48', "48'") // CARGO-26652 箱货信息 新增箱型48‘
export const EQ60_EQ_SIZE = new EQSize('60', "60'") // CARGO-36972 铁路模块增加箱型
export const EQ70_EQ_SIZE = new EQSize('70', "70'") // CARGO-36972 铁路模块增加箱型
export const EQ_SIZES = [EQ20_EQ_SIZE, EQ40_EQ_SIZE, EQ45_EQ_SIZE, EQ10_EQ_SIZE, EQ53_EQ_SIZE, EQ30_EQ_SIZE, EQ48_EQ_SIZE]
export const EQ_SIZES_2 = [EQ20_EQ_SIZE, EQ40_EQ_SIZE, EQ45_EQ_SIZE, EQ10_EQ_SIZE, EQRE_EQ_SIZE, EQ53_EQ_SIZE, EQ30_EQ_SIZE, EQ48_EQ_SIZE]
export const EQ_SIZES_3 = [EQ20_EQ_SIZE, EQ40_EQ_SIZE, EQ45_EQ_SIZE, EQ10_EQ_SIZE, EQRE_EQ_SIZE, EQ53_EQ_SIZE, EQ30_EQ_SIZE, EQ48_EQ_SIZE, EQ60_EQ_SIZE, EQ70_EQ_SIZE]

/**
 *  return null:没找到.
 */
export function getEQSizeByCode(code) {
  // return Model.getObjByCode(code,EQSize.EQ_SIZES) as EQSize;
  return Model.getObjByCode(code, EQ_SIZES_3)
}

/**
 *  return null:没找到.
 */
export function getEQSizeByName(name) {
  // return Model.getObjByCode(code,EQSize.EQ_SIZES) as EQSize;
  return Model.getObjByName(name, EQ_SIZES_3)
}
